export class LoadingMessage {
  constructor(public readonly message: string) {}
}

export interface GlobalState {
  errors: Error[]
  loadingMessages: LoadingMessage[]
}
